export default "__VITE_ASSET__DJcEwF9q__"